import styled from "styled-components";

export const ContainerAsistencia = styled.div`
  /* ${({ isMobile }) => {
    if (isMobile) {
      return `
        width: 320px;
       `;
    } else {
      return `
        width: 365px;
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;
        `;
    }
  }} */
  width: 460px;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  @media (min-height: 700px) {
    width: 350px;
  }
`;

export const HeaderAsistencia = styled.div`
  width: 100%;
  height: 67px;
  background: var(--color-secondary-gradient);
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  color: var(--color-white);
  font-weight: bold;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const BodyAsistencia = styled.div`
  width: 100%;
  height: calc(100% - 67px);
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: center;
  .ptur-turnoConfirmado-tildeTxt {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
  }
  .ptur-circle-turnoConfirmado {
    fill: none;
    stroke: #3d994a;
    stroke-width: 10;
    stroke-dasharray: 283; /* Circumference of the circle (2 * π * r) */
    stroke-dashoffset: 283;
    animation: drawCicle 1.2s ease-in-out forwards;
  }

  .ptur-check-turnoConfirmado {
    fill: none;
    stroke: #3d994a;
    stroke-width: 10;
    stroke-linecap: round;
    stroke-dasharray: 100;
    stroke-dashoffset: 100;
    animation: drawCheck 0.8s ease-in-out forwards;
  }
  @keyframes drawCheck {
    0% {
      stroke-dashoffset: 100;
    }
    100% {
      stroke-dashoffset: 0;
    }
  }
  @keyframes drawCicle {
    0% {
      stroke-dashoffset: 283;
    }
    100% {
      stroke-dashoffset: 0;
    }
  }
`;

export const BtnAceptar = styled.button`
  padding: 14px 10px;
  border-radius: 8px;
  width: 140px;
`;
